export default function useInitialState(callback) {
	if (window.INITIAL_STATE) {
		const result = callback(window.INITIAL_STATE)
		return result ? { ...result } : {}
	}
}
